import { Injectable } from '@angular/core';
import { ConfigService } from '@app/configuration/config.service';

enum SCRIPT_NAMES {
  GAINSIGHT = 'gainsight',
  EID_SDK = 'eid-sdk',
  USERWAY = 'userway',
  TOPNAV = 'topnav'
}

@Injectable()
export class ScriptService {
  static readonly SCRIPT_NAMES = SCRIPT_NAMES;

  private scripts: any = {};

  constructor(configService: ConfigService) {
    const config = configService.getConfig();
    const scriptStore = [
      {
        name: SCRIPT_NAMES.GAINSIGHT,
        id: SCRIPT_NAMES.GAINSIGHT,
        async: true,
        src: `https://web-sdk.aptrinsic.com/api/aptrinsic.js?a=${config.gainSightPXCode}`
      },
      {
        name: SCRIPT_NAMES.EID_SDK,
        id: SCRIPT_NAMES.EID_SDK,
        async: true,
        src: config.eidSdkUrl
      },
      {
        name: SCRIPT_NAMES.USERWAY,
        id: SCRIPT_NAMES.USERWAY,
        async: true,
        src: 'https://cdn.userway.org/widget.js'
      },
      {
        name: SCRIPT_NAMES.TOPNAV,
        id: SCRIPT_NAMES.TOPNAV,
        async: true,
        src: config.topNavBundleUrl
      }
    ];

    scriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        id: script.id,
        src: script.src
      };
    });
  }

  load(...scripts: SCRIPT_NAMES[]): Promise<{ script: string; loaded: boolean; status: string }[]> {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(
    name: SCRIPT_NAMES,
    type = 'text/javascript',
    attributes?: { [key: string]: string }
  ): Promise<{ script: string; loaded: boolean; status: string }> {
    return new Promise((resolve) => {
      //resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        //load script
        const script = document.createElement('script');
        script.type = type;
        script.id = this.scripts[name].id;
        script.src = this.scripts[name].src;
        // script.async = this.scripts[name].async;

        // Add optional attributes
        if (attributes) {
          Object.keys(attributes).forEach((key) => {
            script.setAttribute(key, attributes[key]);
          });
        }

        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }

  removeScript(name: SCRIPT_NAMES): Promise<{ script: string; loaded: boolean; status: string }> {
    return new Promise((resolve) => {
      //resolve if already loaded
      if (!this.scripts[name].loaded) {
        resolve({ script: name, loaded: false, status: 'Script was not loaded' });
      } else {
        //load script
        const element = document.getElementById(this.scripts[name].id);
        if (element) {
          element.remove();
          this.scripts[name].loaded = false;
          resolve({ script: name, loaded: true, status: 'Removed' });
        }

        resolve({ script: name, loaded: true, status: 'Element not found' });
      }
    });
  }
}
